import LocalDatabase from '@/includes/db';
import { Schema } from '@/includes/definitions/index.d';
import { WordsList } from '@/includes/definitions/word.d';

const schema = {
  name: 'WordsList',
  keyPath: 'id',
  autoIncrement: true,
  timestamps: true,
  schema: {
    id: { unique: true },
    name: { unique: false },
    words: { unique: false },
    language: { unique: false },
  },
} as Schema;

export const WordsListModel = LocalDatabase.MakeModel<WordsList>(schema);
export default schema;
